import { useState, useEffect, useContext, ChangeEvent } from "react"
import { useHttp } from "../hooks/http.hook"
import { AuthContext } from "../context/authContext"
import { LoadingBar } from "./loadingBar"

export const MsdsComponent = (props: {page :string}) => {
  const auth = useContext(AuthContext)
  const { loading, request, error, clearError } = useHttp()
  const [link, setLink] = useState('')
  const [form, setForm] = useState({data: ''})
  const [algoritmMethods, setAlgoritmMethods] = useState("Macklin")
  const [empty, setEmpty] = useState([])

  useEffect(()=> {
    // Отрефакторить хук запроса и возвращать весь реквест, чтобы проверять код ответа для логаута вместо проверки на текст.
    if(error === 'Ошибка получения токена доступа') auth.logout()
  }, [error, auth])

  const changeHandler = (e: ChangeEvent) => {
    if (e.target instanceof HTMLInputElement) setForm({...form, [e.target?.name]: e.target?.value})
  }

  const changeAlgoritmMethods = (e: ChangeEvent) => {
    if (e.target instanceof HTMLInputElement && e.target.checked) setAlgoritmMethods(e.target.value)
  }

  const getDataHandler = async (e: any) => {
    if(e.key === 'Enter'){
      clearError()
      setLink('')
      setEmpty([])
      const {empty_files, link} = await request("/products", "POST", {articles: form.data, method: algoritmMethods}, {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth.token}`
      })
      setLink(link)
      setEmpty(empty_files)
    }
  }

  return(
    <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
      <h4>{props.page.toLocaleUpperCase()}</h4>
      <div className="input-field" style={{width: '90%', marginTop: '0', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
        <input
          type="text"
          name="data"
          className="validate"
          placeholder="Введите данные для поиска"
          onChange={changeHandler}
          onKeyDown={getDataHandler}
          value={form.data}
          autoComplete="off"
          disabled={loading}
          style={{width: '80%', alignSelf: 'center'}}
        />
        <div style={{width: '50%', marginTop: '1.5em', display: 'flex', alignItems: 'center'}}>
          {['Macklin'].map((item) =>
            <label key={item}>
              <input type="radio" className="with-gap" value={item} disabled={loading || true} checked={algoritmMethods === item} onChange={changeAlgoritmMethods} name="algoritmRadio" />
              <span>{item}</span>
            </label>
          )}
        </div>
      </div>
      <div style={{width: "95%", marginTop: "4em"}}>
        {
          error && <div className="red-text center-align">{error}</div>
        }
        {
          loading && <LoadingBar text='Идет формирование данных'/>
        }
      </div>
      <div style={{width: "95%"}}>
          {
            link && <div className="red-green center-align" style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
              {
                empty.length > 0 && <span style={{marginBottom: '1em', fontWeight: 'bold'}}>Не удалось скачать msds для артикулов: {empty.join(',')}</span>
              }
              <span style={{marginBottom: '1em'}}>Файл успешно сформирован. Нажмите на ссылку для скачивания.</span>
              <a href={"/uploads/" + link} target="blank" download={link}>Скачать файл</a>
            </div>
          }
        </div>
    </div>
  )
}